import { IMenuItemStyles } from '@fluentui/react/lib/ContextualMenu';
import { HighContrastSelector, ITheme, mergeStyleSets } from '@fluentui/react/lib/Styling';
import { memoizeFunction } from '@fluentui/react/lib/Utilities';

import {
  baseFabricFocusSelector,
  commonHighContrastHoverFocusStyles,
  commonHighContrastOutlineToggledOn,
  getStandardControlSemanticColorsWithTheme,
  IMenuItemClassNames,
  StandardControlSemanticColors,
} from '@1js/acui-common';

import {
  ControlInMenuStylesFunction,
  getClassNamesForMenuButton,
  getStylesFromControlInMenuFnOrObject,
} from '../AppBaseButton/AppBaseButtonInMenu.classNames';

export const getClassNamesForAppToggleButtonInMenu = (
  customMenuItemStyles?: Partial<IMenuItemStyles> | ControlInMenuStylesFunction
) => {
  return memoizeFunction(
    (theme: ITheme, disabled: boolean, expanded: boolean, checked: boolean): IMenuItemClassNames => {
      const standardControlSemanticColors: StandardControlSemanticColors = getStandardControlSemanticColorsWithTheme(
        theme
      );

      return mergeStyleSets(
        getClassNamesForMenuButton()(theme, disabled, expanded),
        {
          root: checked && [
            {
              backgroundColor: standardControlSemanticColors.toggledBackgroundColor,
              border: `1px solid ${standardControlSemanticColors.selectedBorderColor}`,
              selectors: {
                [baseFabricFocusSelector]: {
                  backgroundColor: standardControlSemanticColors.toggledBackgroundColor,
                  borderColor: standardControlSemanticColors.focusedBorderColor,
                },
                [HighContrastSelector]: {
                  border: 'none',
                },
              },
            },
            commonHighContrastOutlineToggledOn,
            commonHighContrastHoverFocusStyles,
          ],
        },
        customMenuItemStyles
          ? getStylesFromControlInMenuFnOrObject(customMenuItemStyles, disabled, expanded, checked)
          : customMenuItemStyles
      );
    }
  );
};
